export default __webpack_public_path__ + "static/media/left-sidebar.6b4a2e8b.md";